import React, { Component } from 'react'
import { Card ,Button,Accordion} from 'react-bootstrap';
import RequestManager from "../../singletons/RequestManager";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import "./subscribecategory.css"
import UnsubscribeCategory from './UnsubscribeCategory';
import LoadingOverlay from "react-loading-overlay";
//import Loading from "../../components/Loading/Loading";


export default class SubScribeCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            storescategory: null,
            spinnerLoading: false,
        };
      }
    
    
      componentDidMount() {
        this.setState({ spinnerLoading: true });
        this.storecategories();
      }
    
    
      storecategories = async () => {
        this.setState({ spinnerLoading: true });
        let requestManager = new RequestManager();
    
        let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

        let params = {};
    
        params ={
          storeId: storeInformation.store.id
           
           }
       
        let response = await requestManager.getResponseFromPredefinedQuery(
          "storecategories",
          params
         
        );
      
        if (response.error === null) {
       
    
        this.setState({
          storescategory: response.data.store.categories.edges,
          spinnerLoading: false,
         });
        // console.log(this.state.deliverydetail[0].node.id)
        //console.log(response.data.store.categories.edges,"categories")
      }
      };
    

    render() {
      const { spinnerLoading } = this.state;
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      
        return (
            <div>
                <h1>Categories</h1>
                <LoadingOverlay
    style={{ width: "100%", height: "100%", zIndex: 999 }}
    active={spinnerLoading === true ? true : false}
    spinner
    text="Loading ..."
  >
{this.state.storescategory && this.state.storescategory.map((categorydetails,index) => {
  
   return(
 
   
                  <Accordion  key={index} defaultActiveKey={index} className="mt-3">
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey={categorydetails.node.id}>
                        {categorydetails.node.name}
                      
                        </Accordion.Toggle>
                        <UnsubscribeCategory categoriesid={categorydetails.node.id} 
                        //  storeid="U3RvcmU6NDcwOGNmYzQtNjhhOC00M2JhLWE3NWQtZWUxN2I1YjU3YTBl"
                        storeid={storeInformation.store.id}
                        categoryname={categorydetails.node.name}
                        />
                      </Card.Header>
                  {categorydetails.node && categorydetails.node.children.edges.map((childrencat, index) => {
                    return(
                      <Accordion.Collapse  key={index} eventKey={categorydetails.node.id}>
                        <Card.Body >
                  <Accordion defaultActiveKey="0">
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey={categorydetails.node.id}>
                        {childrencat.node.name}
                        </Accordion.Toggle>
                        <UnsubscribeCategory categoriesid={childrencat.node.id}
                        // storeid="U3RvcmU6NDcwOGNmYzQtNjhhOC00M2JhLWE3NWQtZWUxN2I1YjU3YTBl"
                        storeid={storeInformation.store.id}
                        categoryname={childrencat.node.name}
                        />
                      </Card.Header>

                      {childrencat.node && childrencat.node.children.edges.map((subchildrencat, index) => {
                    return(


                  <Accordion.Collapse eventKey={categorydetails.node.id} key={index}  >

                        <Card.Body>{subchildrencat.node.name}
                        <UnsubscribeCategory categoriesid={subchildrencat.node.id}
                        // storeid="U3RvcmU6NDcwOGNmYzQtNjhhOC00M2JhLWE3NWQtZWUxN2I1YjU3YTBl"
                        storeid={storeInformation.store.id}
                        categoryname={subchildrencat.node.name}
                        />
                        </Card.Body>
                        

                      </Accordion.Collapse>


                  )
                  })}
                    </Card>
                  
                  </Accordion>
                  </Card.Body>
                      </Accordion.Collapse>
                    )
                  })}
                    </Card>

                  </Accordion>

)
})} 

</LoadingOverlay>
            </div>
            
        )
     
    }
}





// WEBPACK FOOTER //
// ./src/components/subscribecategory/SubScribeCategory.js